import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  const navItems = [
      { path: 'https://www.math.tifrbng.res.in', label:'TIFR-CAM Website' },
      { path: '/', label: 'Latest Events' },
      { path: '/latest-colloquia', label: 'Latest Colloquia' },
      { path: '/all-events', label: 'All Events' },
      { path: 'https://events.tifrbng.res.in/api/feeds/rss', label: 'RSS'},
  ];

  return (
    <nav style={styles.nav}>
      <div style={styles.container}>

	  <Link to="https://events.tifrbng.res.in/">
              <h1 style={styles.title}>TIFR CAM Events</h1>
	  </Link>
        <ul style={styles.navList}>
          {navItems.map((item) => (
            <li key={item.path} style={styles.navItem}>
              <Link
                to={item.path}
                style={{
                  ...styles.navLink,
                  ...(location.pathname === item.path ? styles.activeLink : {}),
                }}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    backgroundColor: '#2c3e50',
    padding: '1rem 0',
    marginBottom: '2rem',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    color: 'white',
    margin: 0,
  },
  navList: {
    listStyle: 'none',
    display: 'flex',
    gap: '2rem',
    margin: 0,
    padding: 0,
  },
  navItem: {
    margin: 0,
  },
  navLink: {
    color: 'white',
    textDecoration: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    transition: 'background-color 0.3s',
  },
  activeLink: {
    backgroundColor: '#34495e',
  },
};

export default Navigation;
